
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

export type ChevronDirection = 'left' | 'right' | 'up' | 'down';

/** Additional input: `direction:'up'|'down'|'left'|'right' = 'down'` for chevron direction. */
@Component({
  selector: 'icon-chevron',
  imports: [],
  templateUrl: './chevron-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChevronIconComponent extends BaseIconComponent {
  readonly direction = input<ChevronDirection>('down');
  readonly double = input(false);
}
